import React from "react";
import multiWorkspaces from "icons/multiWorkspaces.svg";
import PropTypes from "prop-types";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import pen from "icons/pen-icon.svg";
import trash from "icons/trash.svg";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { systemAdminRemoveMemberModal } from "components/Modal/confModalTypes";
import { useDispatch } from "react-redux";

const UsersWorkspaceTableItem = ({
  username,
  multipleWorkspace,
  firstName,
  lastName,
  licensed,
  dictionary,
  readabilitySettings,
  acronymSettings,
  discoverySettings,
  excelOutputs,
  userAdmin,
  workspaceId,
  workspaceName,
}) => {
  const dispatch = useDispatch();
  const handleRemoveMember = () => {
    dispatch(
      showModal(
        modalTypes.CONFIRMATION,
        systemAdminRemoveMemberModal(
          username,
          workspaceName,
          workspaceId,
          dispatch
        )
      )
    );
  };
  return (
    <div
      className="user_admin__container__item__table__row"
      data-testid="users-workspace-table-item"
    >
      <span title={username}>{username}</span>
      {multipleWorkspace ? (
        <span>
          <img
            className="user_admin__container__item__table__row__multiWorkspace__image"
            src={multiWorkspaces}
            alt="multiWorkspaces"
          />
        </span>
      ) : (
        <span>&nbsp;</span>
      )}
      <span title={firstName}>{firstName}</span>
      <span title={lastName}>{lastName}</span>
      <span>
        <Button
          onClick={() => {
            dispatch(
              showModal(modalTypes.EDIT_USER_AND_PERMISSIONS, {
                userName: username,
                currentFirstName: firstName,
                currentLastName: lastName,
                currentLicensed: licensed,
                currentUserAdmin: userAdmin,
                currentReadabilitySettingsAdmin: readabilitySettings,
                currentAcronymSettingsAdmin: acronymSettings,
                currentDiscoverySettingsAdmin: discoverySettings,
                currentExcelOutputsAdmin: excelOutputs,
                currentDictionariesAdmin: dictionary,
              })
            );
          }}
          variant={buttonVariants.borderless}
          data-test="editMemberButton"
          content={<img src={pen} alt="pen" />}
        />
      </span>
      <span>
        <Checkbox
          state={licensed ? checkboxStates.checked : checkboxStates.empty}
          handleChange={() => {}}
          disabled
          id="cblicensed"
          value="license_checkbox"
        />
      </span>
      <span>
        <Checkbox
          state={dictionary ? checkboxStates.checked : checkboxStates.empty}
          handleChange={() => {}}
          disabled
          id="cbdictionary"
          value="dictionary_checkbox"
        />
      </span>
      <span>
        <Checkbox
          state={
            readabilitySettings ? checkboxStates.checked : checkboxStates.empty
          }
          handleChange={() => {}}
          disabled
          id="cbreadabilitysettings"
          value="readability_settings_checkbox"
        />
      </span>
      <span>
        <Checkbox
          state={
            acronymSettings ? checkboxStates.checked : checkboxStates.empty
          }
          handleChange={() => {}}
          disabled
          id="cbacronymsettings"
          value="acronym_settings_checkbox"
        />
      </span>
      <span>
        <Checkbox
          state={
            discoverySettings ? checkboxStates.checked : checkboxStates.empty
          }
          handleChange={() => {}}
          disabled
          id="cbdiscoverysettings"
          value="discovery_settings_checkbox"
        />
      </span>
      <span>
        <Checkbox
          state={excelOutputs ? checkboxStates.checked : checkboxStates.empty}
          handleChange={() => {}}
          disabled
          id="cbexceloutputs"
          value="excel_outputs_checkbox"
        />
      </span>
      <span>
        <Checkbox
          state={userAdmin ? checkboxStates.checked : checkboxStates.empty}
          handleChange={() => {}}
          disabled
          id="cbuseradmin"
          value="user_admin_checkbox"
        />
      </span>
      <span className="user_admin__container__item__table__row__actions">
        <Button
          onClick={handleRemoveMember}
          variant={buttonVariants.borderless}
          data-test="removeMemberButton"
          content={<img src={trash} alt="pen" />}
        />
      </span>
    </div>
  );
};

export default UsersWorkspaceTableItem;

UsersWorkspaceTableItem.propTypes = {
  username: PropTypes.string.isRequired,
  multipleWorkspace: PropTypes.bool.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  licensed: PropTypes.bool.isRequired,
  dictionary: PropTypes.bool.isRequired,
  readabilitySettings: PropTypes.bool.isRequired,
  acronymSettings: PropTypes.bool.isRequired,
  discoverySettings: PropTypes.bool.isRequired,
  excelOutputs: PropTypes.bool.isRequired,
  userAdmin: PropTypes.bool.isRequired,
  workspaceId: PropTypes.number.isRequired,
  workspaceName: PropTypes.string.isRequired,
};
